const passworLength = 5;
const validPassword = (password) => password && password.length > passworLength;

export default validPassword;
